import { useEffect, useState } from "react";
import isFunction from "../utils/isFunction";
import useTrack from "./useTrack";

const useViewTrack = ({ event, properties = {}, canTrack = true, onTrack }) => {
	const track = useTrack();
	const [hasTracked, setHasTracked] = useState(false);

	useEffect(() => {
		if (!event || hasTracked || !canTrack) return;

		const trackInitiator = setTimeout(() => {
			track(event, properties);
			setHasTracked(true);
		}, 0);

		return () => {
			clearTimeout(trackInitiator);
		};
	}, [event, properties, hasTracked, track, canTrack]);

	useEffect(() => {
		if (!hasTracked) return;
		if (isFunction(onTrack)) onTrack();
	}, [hasTracked, onTrack]);

	return { hasTracked, setHasTracked };
};
export default useViewTrack;
